import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux";
import ReactGA from "react-ga4";

import ROUTES from "../../../../utilities/Routes";

import ButtonBack from "../../../../components/Buttons/Back";
import InputText from "../../../../components/Inputs/Text";
import InputSelect from "../../../../components/Inputs/Select";
import InputTextArea from "../../../../components/Inputs/TextArea";
import InputCheckBox from "../../../../components/Inputs/Checkbox";
import { TratoComponent } from "../../../../components/Form/Trato";
import ReactLoading from "react-loading";

import { scrollToInput } from "../../../../utilities/utils";

import {
    setTratamientoAction,
    setNombreAction,
    setApellidoPaternoAction,
    setTelefonoAction,
    setMovilAction,
    setCorreoAction,
    setEstadoAction,
    setCiudadAction,
    setIdConcesionarioAction,
    setConcesionarioAction,
    setTipoCitaAction,
    setComentariosAction,
    setAvisosDePrivacidadAction,
    setTerminosCondicionesAction,
    setTransferenciaDeDatosAction,
    reiniciarStateAction
} from "../../../../actions/contactoActions";

import {
    getEstados,
} from "../../../../API/CitasServicioRequest/index";

import {
    getCiudades,
} from "../../../../API/ConfiguradorRequest/index";

import {
    isOnlyNumbers,
} from "../../../../utilities/Validations";
import { sendMailContactoClienteOtro, sendMailContactoConcesionariaOtro } from "../../../../API/ContactoRequest";
import { validarApellidoPaterno, validarCelular, validarCorreo, validarNombre, validarTelefono } from "../../../../utilities/Validations/lead";
import IFrameResize from "../../../../plugins/template/IFrameRezise";
import { sendLeadToSaas } from "../../../../API/SaasRequest";

const FormularioOtros = () => {
    const dispatch = useDispatch();
    const objSubmit = useSelector((state) => state.contacto);

    let navigate = useNavigate();

    const setTratamiento = (inTratamiento) => {
        dispatch(setTratamientoAction(inTratamiento));
    };
    const setNombre = (inNombre) => {
        dispatch(setNombreAction(inNombre));
    };
    const setApellidoPaterno = (inApellidoPaterno) => {
        dispatch(setApellidoPaternoAction(inApellidoPaterno));
    };
    const setTelefono = (inTelefono) => {
        dispatch(setTelefonoAction(isOnlyNumbers(inTelefono)));
    };
    const setMovil = (inMovil) => {
        dispatch(setMovilAction(isOnlyNumbers(inMovil)));
    };
    const setCorreo = (inCorreo) => {
        dispatch(setCorreoAction(inCorreo));
    };
    const setEstado = (inEstado) => {
        dispatch(setEstadoAction(inEstado));
    };
    const setCiudad = (inCiudad) => {
        dispatch(setCiudadAction(inCiudad));
    };
    const setIdConcesionario = (inIdConcesionario) => {
        dispatch(setIdConcesionarioAction(inIdConcesionario));
    };
    const setConcesionario = (inConcesionario) => {
        dispatch(setConcesionarioAction(inConcesionario));
    };
    const setTipoCita = (inTipoCita) => {
        dispatch(setTipoCitaAction(inTipoCita));
    };
    const setComentarios = (inComentarios) => {
        dispatch(setComentariosAction(inComentarios));
    };
    const setAvisosDePrivacidad = (inAvisosDePrivacidad) => {
        dispatch(setAvisosDePrivacidadAction(inAvisosDePrivacidad));
    };
    const setTerminosCondiciones = (inTerminosCondiciones) => {
        dispatch(setTerminosCondicionesAction(inTerminosCondiciones));
    };
    const setTransferenciaDeDatos = (inAvisosDePrivacidad) => {
        dispatch(setTransferenciaDeDatosAction(inAvisosDePrivacidad));
    };

    const [estados, setEstados] = useState([]);
    const [ciudades, setCiudades] = useState([]);

    const [showErrorEstado, setErrorEstado] = useState(false);
    const [showErrorCiudad, setErrorCiudad] = useState(false);
    const [showErrorDeclaraciones, setErrorDeclaraciones] = useState(false);

    const [loadingSubmit, setLoadingSubmit] = useState(false);
    const [showErrorSubmit, setShowErrorSubmit] = useState(false);

    const filterCiudades = useMemo(() => {
        if (estados.length > 0 && ciudades.length > 0) {
            const estadoSelected = estados.find(
                (edo) => edo.nombreedo === objSubmit.provincia
            );

            if (estadoSelected === undefined) return [];

            return ciudades.filter(
                (cd) => cd.idestado.idestado === estadoSelected.idestado
            );
        }
        return [];
    }, [objSubmit, estados, ciudades]);

    useEffect(() => {
        const funGetEstado = async () => {
            getEstados().then((responseEstados) => {
                setEstados(responseEstados.data);
            });
        };
        const funGetCiudades = async () => {
            getCiudades().then((responseCiudades) => {
                setCiudades(responseCiudades.data);
            });
        };

        funGetEstado();
        funGetCiudades();

        document.title = "Contacto - Otros";
    }, [])

    useEffect(() => {
        if (process.env.REACT_APP_ENABLE_GA4 === "true") {
            // Se inicializa el objeto de analytics para el sitio
            ReactGA.initialize(process.env.REACT_APP_CONTACTO_GA_ID);
        }
    }, []);

    const onSubmit = (e) => {
        e.preventDefault();

        const dataIsvalid = validateForm();

        if (dataIsvalid) {
            setLoadingSubmit(true);
            setShowErrorSubmit(false);
            const lead = { ...objSubmit }

            lead.numeroConcesionaria = objSubmit.numeroConcesionaria < 1000
                ? "0" + objSubmit.numeroConcesionaria
                : "" + objSubmit.numeroConcesionaria

            setTipoCita(process.env.REACT_APP_CONTACTO_ASUNTO_OTRO);

            delete lead.avisoPrivacidad
            delete lead.terminosCondiciones
            delete lead.nombreDelVehiculo

            const contactos = [process.env.REACT_APP_CONTACTO_CORREO_TO];

            lead.descripcion = lead.descripcion.trim() === "" ? "Sin comentarios" : lead.descripcion.trim();

            sendMailContactoClienteOtro({ ...lead, asunto: process.env.REACT_APP_CONTACTO_ASUNTO_OTRO, imgName: "otros-header-mail.jpg" })
                .then(() => {
                    sendMailContactoConcesionariaOtro({ ...lead, contactos })
                    setLoadingSubmit(false);
                    dispatch(reiniciarStateAction());
                    lead.descripcion = process.env.REACT_APP_CONTACTO_ASUNTO_OTRO + " - " + lead.descripcion;	// Se agrega el asunto al inicio de la descripción
                    handleSendLeadToSaas(lead, null, true, process.env.REACT_APP_CONTACTO_ASUNTO_OTRO, "Lead enviado correctamente");

                    navigate(ROUTES.CONTACTOOTROTHANKYOU)
                })
                .catch((error) => {
                    lead.descripcion = process.env.REACT_APP_CONTACTO_ASUNTO_OTRO + " - " + lead.descripcion;	// Se agrega el asunto al inicio de la descripción
                    handleSendLeadToSaas(lead, null, false, process.env.REACT_APP_CONTACTO_ASUNTO_OTRO, error?.response?.data?.message || error?.message || "Error en envío de lead");
                    setLoadingSubmit(false);
                    setShowErrorSubmit(true);
                    console.log("ERROR: ", error);
                });
        }

    }


    const handleSendLeadToSaas = (lead, idTransaccion, status, model, message) => {
        sendLeadToSaas(lead, process.env.REACT_APP_CONTACTO_FORM_ID, idTransaccion, status, model, message)
            .then(respuesta => {
                // manejar respuesta
            })
            .catch(error => {
                // manejar error
                console.error("Error en log: " + error)
            });
    }

    const validateForm = () => {
        if (validarNombre(objSubmit.nombre) === false) {
            scrollToInput("nombre", "Por favor ingresa un nombre válido");
            return false
        }
        if (validarApellidoPaterno(objSubmit.apellidoPaterno) === false) {
            scrollToInput("apellidoPaterno", "Por favor ingresa un valor válido");
            return false;
        }
        if (validarTelefono(objSubmit.telefono) === false) {
            scrollToInput("telefono", "Por favor ingresa un valor válido");
            return false;
        }
        if (validarCelular(objSubmit.celular) === false) {
            scrollToInput("movil", "Por favor ingresa un valor válido");
            return false;
        }
        if (validarCorreo(objSubmit.email) === false) {
            scrollToInput("correo", "Por favor ingresa un valor válido");
            return false;
        }
        if (objSubmit.provincia === "") {
            scrollToInput("estado");
            setErrorEstado(true);
            return false;
        } else {
            setErrorEstado(false);
        }
        if (objSubmit.ciudad === "") {
            scrollToInput("ciudad");
            setErrorCiudad(true);
            return false;
        } else {
            setErrorCiudad(false);
        }

        if (
            objSubmit.avisoPrivacidad === false ||
            objSubmit.terminosCondiciones === false ||
            objSubmit.permisoTransferenciaDatos === false
        ) {
            setErrorDeclaraciones(true);
            return false;
        } else {
            setErrorDeclaraciones(false);
        }

        return true
    }

    return (
        <>
            <IFrameResize IFrameHeight={1900} />
            <main className="audi-nuevo">
                <div className="container mt-4 mb-5 w-100">
                    <ButtonBack />
                </div>
                <section className="container w-100 pt-3">
                    <p className="mb-5">
                        Por favor completa el siguiente formulario. Nos pondremos en contacto contigo para resolver tus dudas y brindarte la información que necesitas.
                    </p>
                    <form className="w-100 pt-5" onSubmit={onSubmit}>
                        <TratoComponent value={objSubmit.tratamiento} onChange={(e) => {setTratamiento(e.target.value)}}/>
                        <h3>Datos de contacto</h3>
                        <div className="fields-grid mt-4 mb-5">
                            <div className="order-1">
                                <InputText
                                    label="¿Cuál es tu nombre?"
                                    name="nombre"
                                    maxLength={40}
                                    onBlur={(e) => {
                                        const value = e.target.value.trim();
                                        e.target.value = value;
                                        setNombre(value);
                                    }}
                                    errorMessage="Carácter no válido, por favor use solo letras."
                                    validator={validarNombre}
                                />
                            </div>
                            <div className="order-2">
                                <InputText
                                    label="¿Cuál es tu apellido?"
                                    name="apellidoPaterno"
                                    maxLength={80}
                                    onBlur={(e) => {
                                        const value = e.target.value.trim();
                                        e.target.value = value;
                                        setApellidoPaterno(value);
                                    }}
                                    errorMessage="Carácter no válido, por favor use solo letras."
                                    validator={validarApellidoPaterno}
                                />

                            </div>
                            <div className="order-3">
                                <InputText
                                    label="¿Cuál es tu número de teléfono?"
                                    name="telefono"
                                    value={objSubmit.telefono}
                                    maxLength={10}
                                    onChange={(e) => {
                                        if (e.target.value.length <= 10)
                                            setTelefono(e.target.value);
                                    }}
                                    errorMessage="Introduzca un número de teléfono válido a 10 dígitos."
                                    validator={validarTelefono}
                                />
                            </div>
                            <div className="order-4 order-lg-5">
                                <InputText
                                    label="¿Cuál es tu número móvil?"
                                    name="movil"
                                    value={objSubmit.celular}
                                    maxLength={10}
                                    onChange={(e) => {
                                        if (e.target.value.length <= 10)
                                            setMovil(e.target.value);
                                    }}
                                    errorMessage="Introduzca un número de teléfono válido a 10 dígitos."
                                    validator={validarCelular}
                                />
                            </div>
                            <div className="order-5 order-lg-7">
                                <InputText
                                    label="¿Cuál es tu e-mail?"
                                    name="correo"
                                    value={objSubmit.email}
                                    maxLength={80}
                                    onChange={(e) => {
                                        if (e.target.value.length <= 80)
                                            setCorreo(e.target.value);
                                    }}
                                    errorMessage="Por favor use un e-mail válido con formato: nombre@dominio.com"
                                    validator={validarCorreo}
                                />
                            </div>

                            <div className="order-6 order-lg-4">
                                <InputSelect
                                    label="Estado"
                                    name="estado"
                                    value={objSubmit.provincia}
                                    options={estados.map((item, i) => ({
                                        value: item.nombreedo,
                                        label: item.nombreedo,
                                    }))}
                                    onChange={(e) => {
                                        setEstado(e.target.value);
                                        setCiudad("");
                                        setIdConcesionario("");
                                        setConcesionario("");
                                        setErrorEstado(false);
                                    }}
                                    errorMessage="Selecciona una opción"
                                    showError={showErrorEstado}
                                    defaultValue={objSubmit.estado}
                                />
                            </div>
                            <div className="order-7 order-lg-6">
                                <InputSelect
                                    label="Ciudad"
                                    name="ciudad"
                                    value={objSubmit.ciudad}
                                    options={filterCiudades.map((item, i) => ({
                                        value: item.nombrecd,
                                        label: item.nombrecd,
                                    }))}
                                    onChange={(e) => {
                                        setCiudad(e.target.value);
                                        setErrorCiudad(false);
                                    }}
                                    disabled={objSubmit.provincia === ""}
                                    showError={showErrorCiudad}
                                    errorMessage="Selecciona una opción"
                                    defaultValue={objSubmit.ciudad}
                                />
                            </div>
                        </div>
                        <div className="">
                            <InputTextArea
                                name="comentarios"
                                placeholder="Mensaje"
                                errorMessage="Su comentario excede los 1,000 caracteres"
                                maxLength={1000}
                                onChange={(e) => {
                                    const value = e.target.value.trim();
                                    if (value.length <= 1000)
                                        setComentarios(value);
                                }}
                                isValid={true}
                            />
                        </div>
                        <div className="mt-5 pt-5">
                            <h3 >Estamos comprometidos con tu privacidad</h3>
                            <p className="mt-4 pb-5">
                                En Audi usamos la información que nos proporcionas para ofrecerte contenido de valor sobre los productos y servicios con los que contamos. Permítenos brindarte una mejor experiencia, a través de un contacto personalizado al aceptar los siguientes avisos:
                            </p>

                            <div className="d-flex flex-column gap-3">
                                <InputCheckBox
                                    rounded
                                    label="Aceptar todo"
                                    onChange={(e) => {

                                        var checkboxes =
                                            document.getElementsByName("checkboxgroup");

                                        checkboxes.forEach((cbx) => {
                                            cbx.checked = e.target.checked;
                                        });
                                        setAvisosDePrivacidad(e.target.checked);
                                        setTerminosCondiciones(e.target.checked);
                                        setTransferenciaDeDatos(e.target.checked);
                                    }}
                                />

                                <InputCheckBox
                                    name="checkboxgroup"
                                    onChange={(e) => {
                                        setAvisosDePrivacidad(e.target.checked);
                                    }}
                                >
                                    <span>
                                        He leído y acepto el{" "}
                                        <a
                                            href="https://www.audi.com.mx/es/tools/navigation/layer/legal/"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            Aviso de Privacidad.
                                        </a>
                                    </span>
                                </InputCheckBox>
                                <InputCheckBox
                                    name="checkboxgroup"
                                    onChange={(e) => {
                                        setTerminosCondiciones(e.target.checked);
                                    }}
                                >
                                    <span>
                                        He leído y acepto el{" "}
                                        <a
                                            href="https://www.audi.com.mx/es/tools/navigation/layer/imprint/"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            Términos y Condiciones.
                                        </a>
                                    </span>
                                </InputCheckBox>
                                <InputCheckBox
                                    label="Acepto que los datos aquí proporcionados sean transferidos al Concesionario marca Audi que he elegido, para darle seguimiento a mi solicitud."
                                    name="checkboxgroup"
                                    onChange={(e) => {
                                        setTransferenciaDeDatos(e.target.checked);
                                    }}
                                />

                                <span
                                    className={`inValid-input ${showErrorDeclaraciones ? "" : "d-none"
                                        }`}
                                >
                                    Para continuar, acepta nuestras declaraciones de conformidad.
                                </span>

                            </div>

                        </div>
                        <div>
                            {!loadingSubmit ? (
                                <button className={`button-enviar`} type="submit">
                                    Enviar
                                </button>
                            ) : (
                                <button
                                    className="button-enviar disabled"
                                    type="button"
                                    disabled={true}
                                >
                                    <div className="loading-g loading-send loading-btn">
                                        <div>
                                            <ReactLoading
                                                type="cylon"
                                                color="#fff"
                                                width={"100%"}
                                                height={"58px"}
                                            />
                                        </div>
                                    </div>
                                </button>
                            )}
                        </div>
                        <span
                            className={`mb-5 inValid-input d-block ${!showErrorSubmit ? "d-none" : ""
                                }`}
                        >
                            Hubo un error. Por favor, Intentelo más tarde.
                        </span>
                    </form>
                </section>
            </main>
        </>
    );
};

export default FormularioOtros;